import styled from "styled-components";
import { useDispatch } from 'react-redux';
import { setBusqueda } from "../../redux/actions.js"
import { useSelector } from 'react-redux';

const Container=styled.div` 
display:flex;
flex-direction:row;
font-family: 'Poppins';
text-align:center;
height:22px;
font-size:15px;

`;

const Barra=styled.input`
border-radius:0px 25px 25px 0px;
border:1px solid grey;
width:25vw;
&:focus {
	outline: none;
	border:1px solid green;
}
 `;

 const Title=styled.div`
 display:flex;
 align-items:center;
 justify-content:center;
 border-radius: 25px 0px 0px 25px;
 background-color:#09b5c1;
 color:white;
 width:84px;
 
  `;


export default function Buscador(){
	const dispatch=useDispatch();
	const busqueda=useSelector(state=>state.busqueda);
	
	const handleChange=(e)=>{
		dispatch(setBusqueda(e.target.value))
	};


	return(	
		<Container>
			<Title>buscar </Title>
			<Barra placeholder="ingrese texto a buscar"  onChange={handleChange} value={busqueda} />
		</Container>
		)
}